module.exports = {
	light: {
		'neutral-alpha-01': 'rgba(0, 0, 0, 0.1)',
		'white-invert-alpha-02': 'rgba(255, 255, 255, 0.2)',
		'black-invert': '#000000',
		'white-invert': '#ffffff',
		'neutral-0': '#ffffff',
		'neutral-5': '#F2F2F2',
		'neutral-10': '#e6e6e6',
		'neutral-20': '#cccccc',
		'neutral-30': '#B3B3B3',
		'neutral-40': '#999999',
		'neutral-50': '#757575',
		'neutral-80': '#333333',
		'neutral-90': '#191919',
		'neutral-100': '#000000',

		'accent-40': '#F33333',
		'accent-50': '#F00000',
		'accent-60': '#DA0000',
		'accent-70': '#AA0000',

		'success-5': '#E7F7EA',
		'warning-5': '#FFF1E6',
		'success-50': '#0AAF2E',
		'warning-50': '#FF7300',
	},
	dark: {
		'neutral-alpha-01': 'rgba(255, 255, 255, 0.15)',
		'white-invert-alpha-02': 'rgba(255, 255, 255, 0.2)',
		'black-invert': '#000000',
		'white-invert': '#ffffff',
		'neutral-0': '#000000',
		'neutral-5': '#262626',
		'neutral-10': '#333',
		'neutral-20': '#404040',
		'neutral-30': '#595959',
		'neutral-40': '#737373',
		'neutral-50': '#8C8C8C',
		'neutral-80': '#CCCCCC',
		'neutral-90': '#E6E6E6',
		'neutral-100': '#FFFFFF',

		'accent-40': '#F33333',
		'accent-50': '#F00000',
		'accent-60': '#DA0000',
		'accent-70': '#AA0000',

		'success-5': '#03300D',
		'warning-5': '#472000',
		'success-50': '#0AAF2E',
		'warning-50': '#FF7300',
	},
	beta: {
		'neutral-alpha-01': 'rgba(255, 255, 255, 0.15)',
		'white-invert-alpha-02': 'rgba(0, 0, 0, 0.1)',
		'black-invert': '#000000',
		'white-invert': '#000000',
		'neutral-0': '#000000',
		'neutral-5': '#262626',
		'neutral-10': '#333',
		'neutral-20': '#404040',
		'neutral-30': '#595959',
		'neutral-40': '#737373',
		'neutral-50': '#8C8C8C',
		'neutral-80': '#CCCCCC',
		'neutral-90': '#E6E6E6',
		'neutral-100': '#FFFFFF',

		'accent-40': '#F33333',
		'accent-50': '#C4FD61',
		'accent-60': '#DA0000',
		'accent-70': '#AA0000',

		'success-5': '#03300D',
		'warning-5': '#472000',
		'success-50': '#0AAF2E',
		'warning-50': '#FF7300',
	},
}
